'use client';

import posthog from 'posthog-js';
import { useEffect } from 'react';

import { captureEvent } from '@/core/analytics/posthog/capture-event';
import {
  PENDING_LOGIN_STORAGE_KEY,
  POSTHOG_EVENTS,
} from '@/core/analytics/posthog/utils/constants';
import { type UserRole } from '@/lib/constants/user';

type IdentifiedUser = {
  id: string;
  email: string;
  role: UserRole;
  groupId: string | null;
};

export const PostHogIdentifyClient = ({
  user,
}: {
  user: IdentifiedUser | null;
}) => {
  useEffect(() => {
    if (user === null) {
      posthog.reset();
      return;
    }
    posthog.identify(user.id, {
      email: user.email,
      role: user.role,
      group_id: user.groupId,
    });

    if (sessionStorage.getItem(PENDING_LOGIN_STORAGE_KEY) === '1') {
      sessionStorage.removeItem(PENDING_LOGIN_STORAGE_KEY);
      captureEvent({ name: POSTHOG_EVENTS.userLogin });
    }
  }, [user]);
  return null;
};
